import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './create-sk-lkrl.actions';
import { CreateSkLkrlState } from './create-sk-lkrl.state';

/**
 * createSkLkrl initial state
 */
export const createSkLkrlInitialState: CreateSkLkrlState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for CreateSkLkrl Store
 */
export const createSkLkrlReducerFeatures: ReducerTypes<CreateSkLkrlState, ActionCreator[]>[] = [
  on(actions.setCreateSkLkrl, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateCreateSkLkrl, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetCreateSkLkrl, () => createSkLkrlInitialState),

  on(actions.cancelCreateSkLkrlRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failCreateSkLkrl, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setCreateSkLkrlFromApi, actions.updateCreateSkLkrlFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * CreateSkLkrl Store reducer
 */
export const createSkLkrlReducer = createReducer(createSkLkrlInitialState, ...createSkLkrlReducerFeatures);
